import { appKeyApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';

export const APP_KEYS_ACTION_TYPE = {
  GET_APP_KEYS_REQUEST: 'GET_APP_KEYS_REQUEST',
  GET_APP_KEYS_SUCCESS: 'GET_APP_KEYS_SUCCESS',
  GET_APP_KEYS_FAILURE: 'GET_APP_KEYS_FAILURE',
  CREATE_APP_KEY: 'CREATE_APP_KEY',
  UPDATE_APP_KEY: 'UPDATE_APP_KEY',
  DELETE_APP_KEY: 'DELETE_APP_KEY',
  TOGGLE_APP_KEY_ACTIVE: 'TOGGLE_APP_KEY_ACTIVE',
};

const appKeySchema = new schema.Entity('appKeys', {}, { idAttribute: 'id' });

const appKeysListSchema = [appKeySchema];

export const getAppKeysAction = catchAsyncActionError(({ companyId }) => async dispatch => {
  dispatch({ type: APP_KEYS_ACTION_TYPE.GET_APP_KEYS_REQUEST });

  const response = await appKeyApi.getAllAppKeys(companyId);
  const normalized = normalize(response.data, appKeysListSchema);

  dispatch({
    type: APP_KEYS_ACTION_TYPE.GET_APP_KEYS_SUCCESS,
    payload: normalized.entities.appKeys || {},
  });
});

export const createAppKeyAction = catchAsyncActionError(payload => async dispatch => {
  const response = await appKeyApi.createAppKey(payload);
  const normalized = normalize(response.data, appKeySchema);

  dispatch({
    type: APP_KEYS_ACTION_TYPE.CREATE_APP_KEY,
    payload: normalized.entities.appKeys,
  });

  return response.data;
});

export const updateAppKeyAction = catchAsyncActionError(payload => async dispatch => {
  const { id, ...data } = payload;

  const response = await appKeyApi.updateAppKey(id, data);
  const normalized = normalize(response.data, appKeySchema);

  dispatch({
    type: APP_KEYS_ACTION_TYPE.UPDATE_APP_KEY,
    payload: normalized.entities.appKeys,
  });

  return response.data;
});

export const deleteAppKeyAction = catchAsyncActionError(({ id }) => async dispatch => {
  await appKeyApi.deleteAppKey(id);

  dispatch({
    type: APP_KEYS_ACTION_TYPE.DELETE_APP_KEY,
    payload: { id },
    meta: { id },
  });
});
